import React, { memo, useEffect, useMemo } from 'react';
import { Field, useField, useForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import ProjectsSelect from '../../../../components/projects-select/ProjectsSelect';

import scss from './AddUserForm.module.scss';

function AssignProjects({ assignedCompanyProjects }) {
  const { t } = useTranslation('customers');

  const assignProjectsInput = useField('assignedProjects').input;
  const form = useForm();

  const formattedCompanyProjects = useMemo(
    () => assignedCompanyProjects.map((project) => ({ ...project, enabled: true })),
    [assignedCompanyProjects],
  );

  const handleSelectProject = ({ id, checked }) => {
    if (checked) {
      form.change('assignedProjects', [...assignProjectsInput.value, id]);
    }

    if (!checked) {
      form.change(
        'assignedProjects',
        assignProjectsInput.value.filter((projectId) => projectId !== id),
      );
    }
  };

  useEffect(() => {
    if (assignProjectsInput.value && assignProjectsInput.value.length)
      form.change(
        'assignedProjects',
        assignProjectsInput.value.filter((projectId) => assignedCompanyProjects.some(({ id }) => id === projectId)),
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignedCompanyProjects]);

  return (
    <Field name='assignedProjects'>
      {({ input }) => (
        <WithLabel label={t('assignProjects')} variant={LABEL_STYLES.COLUMN}>
          <ProjectsSelect
            projectList={formattedCompanyProjects}
            activeProjects={input.value}
            onSelect={handleSelectProject}
            className={scss.assignedProjectsWrapper}
          />
        </WithLabel>
      )}
    </Field>
  );
}

export default memo(AssignProjects);
